import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import {
  Container, Spinner, Button, Modal, Form, Card, Row, Col
} from "react-bootstrap";
import ReportForm from "../components/Report/ReportForm";
import "../styles/subjectpage.css";
import api from "../api.js";

const SubjectPage = () => {
  const { id } = useParams();
  const token = Cookies.get("access_token");
  const currentUser = Cookies.get("user_id");
  const currentRole = Cookies.get("user_role");
  const navigate = useNavigate();

  const [subject, setSubject] = useState(null);
  const [subjects, setSubjects] = useState([]); // ✅ for parent dropdown
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showReportForm, setShowReportForm] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [editData, setEditData] = useState({
    title: "",
    description: "",
    parent: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [subjectRes, allSubjectsRes, reportRes] = await Promise.all([
          api.get(`/subject/${id}/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          api.get(`/subject/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          api.get(`/report/subject/${id}/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setSubject(subjectRes.data);
        setSubjects(allSubjectsRes.data);
        setReports(reportRes.data);

        setEditData({
          title: subjectRes.data.title,
          description: subjectRes.data.description,
          parent: subjectRes.data.parent ? subjectRes.data.parent.id : null,
        });

      } catch (err) {
        if (err.response?.status === 401) navigate("/login");
        else setError("خطا در دریافت اطلاعات موضوع");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      await api.patch(`/subject/${id}/`, {
        ...editData,
        parent: editData.parent || null,
        author: currentUser,
        field: subject.field.id,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setShowEdit(false);
      window.location.reload();
    } catch (err) {
      if (err.response?.status === 401) navigate("/login");
      else console.error("Error updating subject:", err);
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/subject/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate(`/field/${subject.field.id}`);
    } catch (err) {
      if (err.response?.status === 401) navigate("/login");
      else console.error("Error deleting subject:", err);
    }
  };

  if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;
  if (error) return <div className="text-danger text-center mt-4">{error}</div>;

  return (
    <Container className="subject-page-container py-4" dir="rtl">
      <Card className="subject1 p-4 shadow-sm mb-4">
        <div className="subject-page d-flex justify-content-between align-items-center">
          <div>
            <h2 className="text-primary1 fw-bold">{subject.title}</h2>
            <p className="text-muted2 small">تاریخ ایجاد: {new Date(subject.created_at).toLocaleDateString("fa-IR")}</p>
            {subject.description && <p className="mt-2">{subject.description}</p>}
            <p className="text-muted2">تعداد گزارش ها: {subject.report_count.toLocaleString("fa-IR")}</p>
            {subject.field && (
              <p className="text-muted2">
                حوزه: <Link to={`/field/${subject.field.id}`}>{subject.field.title}</Link>
              </p>
            )}
          </div>
          {(String(subject.author) === currentUser || currentRole === "Manager" || currentRole === "admin") && (
            <div className="d-flex flex-column gap-2">
              <Button className="btn-edit" variant="outline-primary" onClick={() => setShowEdit(true)}>ویرایش</Button>
              <Button className="btn-delete" variant="outline-danger" onClick={() => setShowDelete(true)}>حذف</Button>
            </div>
          )}
        </div>
      </Card>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="text-primary2">گزارش‌های این موضوع</h4>
        {subject.field.users_with_access.includes(Number(currentUser)) && (
        <Button className="btn-add" variant="success" onClick={() => setShowReportForm(true)}>افزودن گزارش</Button>
        )}
      </div>

      <Row className="g-3">
        {reports.length === 0 ? (
          <p className="text-muted2">هیچ گزارشی موجود نیست.</p>
        ) : reports.map((report) => (
          <Col md={4} lg={3} key={report.id}>
            <Card className="report-card h-100 shadow-sm">
  {report.picture && (
    <Card.Img
      variant="top"
      src={report.picture}
      alt={report.title}
      style={{ height: "180px", objectFit: "cover" }}
      onClick={() => navigate(`/report/${report.id}`)}
    />
  )}
  <Card.Body>
    <Card.Title
      className="report-card-title"
      onClick={() => navigate(`/report/${report.id}`)}
      style={{ cursor: "pointer" }}
    >
      {report.title}
    </Card.Title>

    {/* نام کاربری نویسنده */}
    {report.author && (
      <p className="text-muted small mb-1">
        نویسنده: {report.author.username}
      </p>
    )}

    {/* تعداد بازدید به فارسی */}
    <p className="text-muted small mb-0">
      تعداد بازدید: {new Intl.NumberFormat("fa-IR").format(report.view_count)}
    </p>
  </Card.Body>
</Card>


          </Col>
        ))}
      </Row>

      <ReportForm
        show={showReportForm}
        handleClose={() => setShowReportForm(false)}
        subjectId={subject.id}
        onSuccess={() => window.location.reload()}
      />

      {/* Edit Modal */}
      <Modal show={showEdit} onHide={() => setShowEdit(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>ویرایش موضوع</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEdit}>
            <Form.Group className="mb-3">
              <Form.Label>عنوان</Form.Label>
              <Form.Control
                value={editData.title}
                onChange={(e) =>
                  setEditData({ ...editData, title: e.target.value })
                }
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>توضیحات</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={editData.description}
                onChange={(e) =>
                  setEditData({ ...editData, description: e.target.value })
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>والد</Form.Label>
              <Form.Select
  value={editData.parent ?? ""}
  onChange={(e) =>
    setEditData({
      ...editData,
      parent: e.target.value === "" ? null : parseInt(e.target.value),
    })
  }
>

                <option value="">— بدون والد —</option>
                {subjects
                  .filter((s) => s.id !== subject.id)
                  .map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.title}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>

            <div className="text-end">
              <Button className="btn-submit" type="submit" variant="success">
                ثبت
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Delete Modal */}
      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered>
        <Modal.Header closeButton />
        <Modal.Body>آیا از حذف این موضوع مطمئن هستید؟</Modal.Body>
        <Modal.Footer>
          <Button className="btn-edit" variant="secondary" onClick={() => setShowDelete(false)}>لغو</Button>
          <Button variant="danger" onClick={handleDelete}>حذف</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default SubjectPage;
